import { useEffect, useState } from 'react';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

const storageProvider = createLocalStorageProvider('dashboard-banners');

export const useBanner = (bannerId: string) => {
	const [isDismissed, setIsDismissed] = useState(false);
	useEffect(() => {
		const checkDismissedState = () => {
			const dismissedBanners = storageProvider.get('dismissedBanners') || {};
			setIsDismissed(!!dismissedBanners[bannerId]);
		};

		checkDismissedState();
	}, [bannerId]);

	const handleDismiss = () => {
		const dismissedBanners = storageProvider.get('dismissedBanners') || {};
		storageProvider.set('dismissedBanners', {
			...dismissedBanners,
			[bannerId]: true,
		});
		setIsDismissed(true);
	};

	return { isDismissed, handleDismiss };
};
